<template>
    <div class="multi-event-container">
        <div class="multi-event-header">
            <h1>{{ title }}</h1>
        </div>
        <div class="no-events" v-if="!hasEvents">
            <p>There are currently no events available for this sport</p>
        </div>
        <div class="meeting-container" v-else-if="hasEvents && meetingID">
            <div class="meeting-header solo">
                <h2>{{ getMeeting(category).name }}</h2>
            </div>
            <div class="meeting-body solo">
                <div class="event-container" v-for="event in meetingEvents(category, meetingID)" :key="event.ID">
                    <div class="event-header">
                        <h2>{{ event.name }}</h2>
                        <span class="event-start-time">{{ event.startTime }}</span>
                        <p>{{ event.eachWay }}</p>
                    </div>
                    <div class="event-body">
                        <table class="table" :class="{ 'is-bordered' : isBordered, 'is-striped' : isStriped, 'is-narrow' : isNarrow, 'is-hoverable' : isHoverable, 'is-fullwidth' : isFullwidth }" v-if="meetingID">
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Selection</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="selection in event.selections" :key="selection.name">
                                    <td class="selection-number">
                                        {{ selection.number }}
                                    </td>
                                    <td>
                                        <div class="selection-name-details">
                                            <strong class="selection-name"><img class="selection-colour" :src="getColours(selection.silks, event.VRAintree)"> {{ selection.name }}</strong>
                                            <span class="selection-details" v-if="selection.jockey != undefined && selection.jockey != ''">J: {{ selection.jockey }}</span>
                                        </div>
                                    </td>
                                    <td class="price">
                                        <span>
                                            {{ selection.price }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="meeting-container" v-for="(meeting, key) in localEventData.categories[category].events" :key="key" v-else>
            <div class="meeting-header">
                <h2>{{ meeting.name }}</h2>
            </div>
            <div class="meeting-body">
                <table class="table" :class="{ 'is-bordered' : isBordered, 'is-striped' : isStriped, 'is-narrow' : isNarrow, 'is-hoverable' : isHoverable, 'is-fullwidth' : isFullwidth }">
                    <thead>
                        <tr>
                            <th>Event</th>
                            <th>Start Time</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="event in meeting.events" :key="event.ID">
                            <td>{{ event.name }}</td>
                            <td>{{ event.startTime }}</td>
                            <td>
                                <router-link tag="button" :to="'/categories/' + category + '/' + key + '/' + event.ID" class="button view-event-btn">
                                    View Event
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../main';

export default {
    props: [ 'isMobile', 'category', 'meetingID', 'menuData', 'eventData' ],
    data() {
        return {
            isBordered: true,
            isStriped: true,
            isNarrow: false,
            isHoverable: true,
            isFullwidth: false,
            localMenuData: this.menuData,
            localEventData: this.eventData,
            hasEvents: false
        }
    },
    created() {
        this.noEvents();

        eventBus.$on('menuLoaded', (data) => {
            this.localMenuData = data[1];
            this.noEvents();
            this.setEvents(data[0]);
        });

        eventBus.$on('eventsLoading', (data) => {
            this.localEventData = data;
            this.noEvents();
            this.$forceUpdate();
        });
    },
    computed: {
        title() {
            if(typeof this.meetingID != 'undefined' && typeof this.localMenuData.categories[this.category][this.meetingID] != 'undefined') {
                return this.localMenuData.categories[this.category][this.meetingID].name;
            } else {
                return this.localMenuData.categories[this.category].name;
            }
        }
    },
    methods: {
        getEachWay(reduction, placeTerms) {
            if(reduction == 1 && placeTerms == 1) {
                return 'Win only';
            }

            var red = '1/' + reduction;

            var place = placeTerms;

            for(let i = place - 1; i > 0; i--) {
                place = i + '-' + place;
            }

            return 'Each way ' + red + ' odds ' + place;
        },
        getMeeting(category) {
            if(typeof this.localEventData.categories[category].events[this.meetingID] == 'undefined') return {};
            return this.localEventData.categories[category].events[this.meetingID];
        },
        meetingEvents(category, meetingID) {
            if(typeof this.localEventData.categories[category].events[meetingID] == 'undefined') return [];

            return this.localEventData.categories[category].events[meetingID].events;
        },
        noEvents() {
            if(typeof this.localEventData == 'undefined' || typeof this.localEventData.categories[this.category].events == 'undefined' || Object.keys(this.localEventData.categories[this.category].events).length === 0) {
                this.hasEvents = false;
                return true;
            }

            var hasLength = false;

            if(this.meetingID) {
                if(typeof this.localEventData.categories[this.category].events[this.meetingID] == 'undefined') return true;

                hasLength = ((this.localEventData.categories[this.category].events[this.meetingID].events.length) > 0 ? true : false);
            } else {
                for(let key in this.localEventData.categories[this.category].events) {
                    let meeting = this.localEventData.categories[this.category].events[key];
                    
                    if(meeting.events.length > 0) hasLength = true;
                }
            }

            this.hasEvents = hasLength;

            return !hasLength;
        },
        fromUrl(str, preserveHyphens = false) {
            let tmp = str;

            if(preserveHyphens == false) {
                tmp = tmp.replace(/-/g, ' ');
            }
            tmp = tmp.replace(/_/g, '/');
            if(preserveHyphens == false) {
                tmp = tmp.split(' ');
            } else {
                tmp = tmp.split('-');
            }
            tmp.forEach((item, ind) => {
                if(item == 'vip') {
                    tmp[ind] = item.toUpperCase();
                } else {
                    tmp[ind] = item.charAt(0).toUpperCase() + item.slice(1);
                }
            });
            if(preserveHyphens == false) {
                tmp = tmp.join(' ');
            } else {
                tmp = tmp.join('-');
            }
            return tmp;
        },
        getColours(index, VRAintree = false) {
            let toUse = '';
            let prefix = '';
            let error = false;

            switch(this.category) {
                case 'vip-horse':
                    toUse = 'horses';
                    prefix = 'H';
                    break;
                case 'vip-greyhound':
                    toUse = 'greyhounds';
                    prefix = 'G';
                    break;
                case 'vip-cycling':
                    toUse = 'cycling';
                    prefix = 'C';
                    break;
                case 'vip-motor-racing':
                    toUse = 'motorracing';
                    prefix = 'M';
                    break;
                case 'vip-speedway':
                    toUse = 'speedway';
                    prefix = 'S';
                    break;
                default:
                    error = true;
                    break;
            }
            if(VRAintree) {
                prefix = 'V';
            }
            if(error) {
                return '';
            }
            let path ='/dist/VIP' + prefix + index + '.png';
            return path;
            // if(error) {
            //     return false;
            // }
            //
            // try {
            //     var pathToImg = require('../assets/img/colours/' + toUse + '/VIP' + prefix + index + '.png');
            // } catch(e) {
            //     var pathToImg = '';
            // }
            //
            // return pathToImg;
        },
        setEvents(load = true) {
            if(load == true) eventBus.$emit('loading', ['MultiEvent', true]);
            
            var _self = this;
            var events = [];
            var onlyIDs = false;

            if(!this.meetingID) {
                onlyIDs = true;
            }

            if(!(this.category in this.localMenuData.categories)) {
                // No events exist for this category
                if(load == true) eventBus.$emit('loading', ['MultiEvent', false]);
                return;
            }

            if(load == true) eventBus.$emit('loading', ['MultiEvent', true]);

            if(this.meetingID) {
                this.localMenuData.categories[this.category].events[this.meetingID].events.forEach((event) => {
                    if(!event.selections && !onlyIDs) event.updated = 0;

                    events.push({
                        'ID': event.ID,
                        'updated': event.updated
                    });
                });
            } else {
                for(let key in this.localMenuData.categories[this.category].events) {
                    let meeting = this.localMenuData.categories[this.category].events[key];

                    meeting.events.forEach((event) => {
                        events.push({
                            'ID': event.ID,
                            'updated': event.updated
                        });
                    });
                }
            }

            if(load == true) eventBus.$emit('loading', ['MultiEvent', true]);

            this.$API.GetEvents(events, onlyIDs, true, (response) => {
                let res = response.result;
                let tmpEvents = [];

                if(response.status == 0) {
                    console.error(res.error);
                    if(load == true) eventBus.$emit('loading', ['MultiEvent', false]);
                    return;
                }
                
                if(res.errors || ('update' in res && res.update == false)) {
                    if(load == true) eventBus.$emit('loading', ['MultiEvent', false]);
                    return;
                }

                res.forEach((event) => {
                    if(!onlyIDs) {
                        let eachWay = this.getEachWay(event.EWReduction, event.EWPlaceTerms);

                        var tmp = {
                            'ID': event.ID,
                            'name': event.name,
                            'category': _self.category,
                            'meetingID': event.meetingID,
                            'meetingName': event.meetingName,
                            'startTime': event.startTime,
                            'eachWay': eachWay,
                            'selections': [],
                            'updated': event.updated,
                            'VRAintree' : false
                        };
                        if(tmp.name.toUpperCase().indexOf('AINTREE (VR)') > -1) {
                            tmp.VRAintree = true;
                        }
                        let selections = event.selections;

                        selections.forEach((selection) => {
                            let tmpSel = {
                                'number': selection.number,
                                'name': selection.name,
                                'jockey': selection.jockey,
                                'silks': selection.silks,
                                'price': selection.price
                            };

                            tmp['selections'].push(tmpSel);
                        });

                        tmp.selections.sort(this.compareSelections);
                    } else {
                        var tmp = {
                            'ID': event.ID,
                            'name': event.name,
                            'category': _self.category,
                            'meetingID': event.meetingID,
                            'meetingName': event.meetingName,
                            'startTime': event.startTime,
                            'updated': event.updated
                        };
                    }

                    tmpEvents.push(tmp);
                });

                tmpEvents.sort(this.compareEvents);

                tmpEvents.forEach((event) => {
                    var found = false;

                    for(let key in this.localEventData.categories[this.category].events) {
                        let meeting = this.localEventData.categories[this.category].events[key];

                        meeting.events.forEach((meetingEvent) => {
                            if(meetingEvent.ID == event.ID) {
                                found = true;
                                eventBus.$emit('updateEvent', {
                                    'category': this.category,
                                    'event': event
                                });
                            }
                        });
                    }

                    if(!found) {
                        eventBus.$emit('addEvent', {
                            'category': this.category,
                            'event': event
                        });
                    }
                });

                for(let c in this.localEventData.categories) {
                    let category = this.localEventData.categories[c];

                    for(let m in category.events) {
                        let meeting = category.events[m];

                        meeting.events.forEach((event) => {
                            var found = false;

                            tmpEvents.forEach((ev) => {
                                if(ev.ID == event.ID) {
                                    found = true;
                                }
                            })

                            // if(found == false) {
                            //     eventBus.$emit('deleteEvent', {
                            //         'eventID': event.ID,
                            //         'meetingID': m,
                            //         'category': c
                            //     });
                            // }
                        });
                    }
                }

                eventBus.$emit('updateEventUpdated', tmpEvents);
                this.$forceUpdate();
                eventBus.$emit('eventLoaded');

                if(load == true) eventBus.$emit('loading', ['MultiEvent', false]);
            });
        },
        compareEvents(a, b) {
			if(a.name < b.name) return -1;
			if(a.name > b.name) return 1;
			return 0;
        },
        compareSelections(a, b) {
            if(parseInt(a.number) < parseInt(b.number)) return -1;
            if(parseInt(a.number) > parseInt(b.number)) return 1;
            return 0;
        }
    }
}
</script>

<style lang="less">
.multi-event-container {
    width: 100%;

    .multi-event-header {
        background-color: #808080;
        border: 2px solid darken(#808080, 10%);
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 5px 10px;

        h1 {
            font-family: 'Staatliches', 'Open Sans', sans-serif;
            font-weight: bold;
            font-size: 32px;
            text-transform: uppercase;
            color: #F9D71E;
        }
    }

    .no-events {
        background-color: #fff;
        border: 2px solid darken(#808080, 10%);
        border-radius: 5px;
        padding: 5px 10px;
    }

    .meeting-container {
        width: 100%;
        margin-bottom: 15px;

        .meeting-header {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            padding: 5px 10px;
            background-color: #808080;
            border: 2px solid darken(#808080, 10%);
            border-bottom: 0;

            h2 {
                font-family: 'Staatliches', 'Open Sans', sans-serif;
                font-size: 24px;
                text-transform: uppercase;
                color: #F9D71E;
            }

            &.solo {
                border-radius: 5px;
                margin-bottom: 15px;
                border-bottom: 2px solid darken(#808080, 10%);
            }
        }

        .meeting-body {
            width: 100%;
            border: 2px solid darken(#808080, 10%);
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            border-top: 0;
            overflow: hidden;

            &.solo {
                border: none;
            }

            table {
                width: 100%;

                .view-event-btn {
                    background-color: #808080;
                    color: #F9D71E;
                    border: 2px solid darken(#808080, 10%);
                    border-radius: 0;
                    font-family: 'Staatliches', 'Open Sans', sans-serif;
                    text-transform: uppercase;

                    &:hover,
                    &:focus,
                    &:active {
                        border: 2px solid darken(#808080, 10%);
                        color: #808080;
                        background-color: #F9D71E;
                        box-shadow: none !important;
                    }
                }
            }

            &:not(.solo) {
                table {
                    thead tr {
                        th:first-child {
                            width: 75%;
                        }
                        th:nth-child(2) {
                            width: 24%;
                        }
                        th:last-child {
                            width: 1%;
                        }
                    }
                }
            }

            .event-container {
                width: 100%;
                margin-bottom: 15px;

                .event-header {
                    padding: 5px 10px;
                    background-color: #808080;
                    border: 2px solid darken(#808080, 10%);
                    border-bottom: none;

                    h2 {
                        font-family: 'Staatliches', 'Open Sans', sans-serif;
                        font-size: 24px;
                        text-transform: uppercase;
                        color: #F9D71E;
                    }
                    .event-start-time {
                        float: right;
                    }
                    .event-start-time,
                    p {
                        color: #fff;
                        font-size: 14px;
                        padding-bottom: 4px;
                    }
                }

                .event-body {
                    width: 100%;
                    overflow: hidden;

                    table {
                        table-layout: fixed;
                        width: 100%;

                        thead tr {
                            th:first-child {
                                width: 5%;
                                text-align: center;
                            }
                            th:nth-child(2) {
                                width: 80%;
                            }
                            th:last-child {
                                width: 15%;
                            }
                        }

                        .selection-number {
                            text-align: center;
                            vertical-align: middle;
                            font-weight: bold;
                        }

                        .selection-name-details {
                            .selection-name,
                            .selection-details {
                                display: block;
                            }

                            .selection-name {
                                word-wrap: break-word;
                            }

                            .selection-colour {
                                height: 24px;
                            }

                            .selection-details {
                                font-size: 14px;
                            }
                        }

                        .price {
                            vertical-align: middle;

                            span {
                                display: inline-block;
                                text-align: center;
                                font-size: 15px;
                                font-weight: bold;
                                padding: 4px 6px;
                                background-color: #8b0000;
                                border: 2px solid darken(#8b0000, 20%);
                                color: #fff;
                                min-width: 62px;
                                letter-spacing: 0.05em;
                            }
                        }
                    }
                }
            }

            &.solo {
                .event-container {
                    .event-header {
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }

                    .event-body {
                        border: 2px solid darken(#808080, 10%);
                        border-bottom-left-radius: 5px;
                        border-bottom-right-radius: 5px;
                    }
                }
            }
        }
    }
    
    @media (max-width: 1080px) {
        .meeting-container .meeting-body .event-container .event-body table {
            thead tr {
                th:first-child {
                    width: 15%;
                }
                th:nth-child(2) {
                    width: 55%;
                }
                th:last-child {
                    width: 30%;
                }
            }
        }

        .meeting-container:last-child {
            margin-bottom: 10px;
        }
    }
}

@media (max-width: 700px) {
    .multi-event-container {
        padding: 15px 10px 10px 10px;

        .multi-event-header {
            margin-bottom: 10px;
        }

        .event-container {
            &:last-child {
                margin-bottom: 0;
            }
            &:not(:last-child) {
                margin-bottom: 10px;
            }
        }

        .view-event-btn {
            padding: 0 5px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MultiEvent.vue